import Component from './BadgeDelete.component';

export default Component;
